import api from './core/api';
import { ApiResponse } from './core/AbstractService';

export interface InstagramConnection {
  connected: boolean;
  userId?: string;
  username?: string;
  accountType?: string;
  profilePictureUrl?: string;
  followersCount?: number;
  expiresAt?: string;
  daysUntilExpiry?: number;
  source: 'database' | 'env' | 'none';
}

class InstagramService {
  private basePath = '/admin/instagram';

  async getStatus(): Promise<ApiResponse<InstagramConnection>> {
    const response = await api.get<ApiResponse<InstagramConnection>>(
      `${this.basePath}/status`
    );
    return response.data;
  }

  async getConnectUrl(): Promise<ApiResponse<{ url: string }>> {
    const response = await api.get<ApiResponse<{ url: string }>>(
      `${this.basePath}/connect-url`
    );
    return response.data;
  }

  async refreshToken(): Promise<ApiResponse<InstagramConnection>> {
    const response = await api.post<ApiResponse<InstagramConnection>>(
      `${this.basePath}/refresh`
    );
    return response.data;
  }

  async disconnect(): Promise<void> {
    await api.delete(`${this.basePath}/connection`);
  }
}

export const instagramService = new InstagramService();
export default instagramService;
